module.exports = __webpack_public_path__ + "img/bodycheck7.6011becd.png";